const getVideoType = ({
  label,
  buttonPopover,
  customCta,
  playButtonOnly,
  thumbnailOnly,
  thumbnailInline,
  inline,
}) => {
  const videoType = !!label
    ? 'isLabelPopover'
    : buttonPopover || playButtonOnly
    ? 'isButtonPopover'
    : thumbnailOnly
    ? 'isThumbnailOnly'
    : thumbnailInline || inline
    ? 'isThumbnailInline'
    : customCta
    ? 'isCustomCtaPopover'
    : 'isThumbnailPopover';

  return videoType;
};

export default getVideoType;
